// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2ppZv","list":"BalanceDue_list__20oJd","listRow":"BalanceDue_listRow__IILnY","total":"BalanceDue_total__fqLKa"};